import React                       from 'react';
import { createObservableContext } from "@geenee/geeclient-kit/src/packages/shared/lib/util/context/_helpers/create-observable-context";
import type { ProjectType }             from "@geenee/shared/type/project.type";

export const ProjectContext: React.Context<ProjectType[]> =  createObservableContext([] as ProjectType[]);
